var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"act-cards fade-up",staticStyle:{"transition-delay":"0.12s"}},_vm._l((_vm.cardList),function(card,index){return _c('div',{key:'card' + index,staticClass:"act-card"},[_c('ActCard',{attrs:{"card-obj":card,"img-url-prefix":_vm.imgUrlPrefix,"user-head-prefix":_vm.userHeadPrefix}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }